import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import MuiErrorIcon from '@mui/icons-material/Error';
import MuiFormHelperText from '@mui/material/FormHelperText';
import { styled, SxProps, Theme } from '../styles';
import Box from '../Box';
export interface Props {
  hasError?: boolean;
  errorHelperText?: ReactNode;
  helperText?: ReactNode;
  maxLength?: number;
  currentLength?: number;
  minLength?: number;
  sx?: SxProps<Theme>;
  id?: string;
}
const MuiFormHelperTextStyled = styled(MuiFormHelperText)(({
  theme: {
    typography
  }
}) => ({
  fontSize: typography.helper.fontSize,
  letterSpacing: typography.helper.letterSpacing,
  lineHeight: typography.helper.lineHeight,
  fontWeight: typography.helper.fontWeight
})) as typeof MuiFormHelperText;
const MuiFormHelperErrorTextStyled = styled(MuiFormHelperTextStyled)(({
  theme: {
    palette
  }
}) => ({
  '& a, & a:visited, & a:hover': {
    color: palette.error.main
  }
})) as typeof MuiFormHelperText;
const FormHelperText = t0 => {
  const $ = _c(21);
  const {
    helperText: t1,
    hasError: t2,
    errorHelperText: t3,
    maxLength: t4,
    currentLength: t5,
    minLength: t6,
    sx: t7,
    id
  } = t0;
  const helperText = t1 === undefined ? "" : t1;
  const hasError = t2 === undefined ? false : t2;
  const errorHelperText = t3 === undefined ? "" : t3;
  const maxLength = t4 === undefined ? 0 : t4;
  const currentLength = t5 === undefined ? 0 : t5;
  const minLength = t6 === undefined ? 0 : t6;
  let t8;
  if ($[0] !== t7) {
    t8 = t7 === undefined ? {} : t7;
    $[0] = t7;
    $[1] = t8;
  } else {
    t8 = $[1];
  }
  const sx = t8;
  const shouldDisplayHelperWrapper = hasError && errorHelperText || helperText && !hasError || maxLength > 0 || minLength > 0;
  if (!shouldDisplayHelperWrapper) {
    return null;
  }
  let t9;
  if ($[2] !== sx) {
    t9 = {
      display: "flex",
      paddingTop: 0.5,
      ...sx
    };
    $[2] = sx;
    $[3] = t9;
  } else {
    t9 = $[3];
  }
  let t10;
  if ($[4] !== errorHelperText || $[5] !== hasError) {
    t10 = hasError && errorHelperText && <Box sx={{
      display: "flex",
      alignItems: "flex-start",
      flexGrow: 1
    }}><MuiErrorIcon color="error" sx={{
        marginTop: {
          xs: "0.0625rem",
          sm: "0.125rem"
        },
        marginRight: 0.5,
        fontSize: 16,
        lineHeight: 22
      }} /><MuiFormHelperErrorTextStyled aria-live="polite" role="alert" error={true} sx={{
        margin: 0,
        overflowWrap: "break-word",
        maxWidth: "fit-content"
      }} variant="outlined">{errorHelperText}</MuiFormHelperErrorTextStyled></Box>;
    $[4] = errorHelperText;
    $[5] = hasError;
    $[6] = t10;
  } else {
    t10 = $[6];
  }
  let t11;
  if ($[7] !== hasError || $[8] !== helperText) {
    t11 = helperText && !hasError && <MuiFormHelperTextStyled sx={{
      margin: 0,
      overflowWrap: "break-word",
      maxWidth: "fit-content"
    }} variant="outlined">{helperText}</MuiFormHelperTextStyled>;
    $[7] = hasError;
    $[8] = helperText;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== currentLength || $[11] !== hasError || $[12] !== maxLength || $[13] !== minLength) {
    t12 = (maxLength > 0 || minLength > 0) && <MuiFormHelperTextStyled error={hasError} sx={{
      margin: 0,
      marginLeft: "auto",
      paddingLeft: 1,
      whiteSpace: "nowrap"
    }} variant="outlined" component="span">{maxLength > 0 && `${currentLength}/${maxLength}`}{minLength > 0 && `${currentLength}/${minLength} min`}</MuiFormHelperTextStyled>;
    $[10] = currentLength;
    $[11] = hasError;
    $[12] = maxLength;
    $[13] = minLength;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== id || $[16] !== t10 || $[17] !== t11 || $[18] !== t12 || $[19] !== t9) {
    t13 = <Box sx={t9} id={id}>{t10}{t11}{t12}</Box>;
    $[15] = id;
    $[16] = t10;
    $[17] = t11;
    $[18] = t12;
    $[19] = t9;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  return t13;
};
export default FormHelperText;